import { getCart, getOrder } from '@/services/FramedCheckout/orderServices'
import { updateShippingOption } from '@/services/FramedCheckout/shipmentServices/updateShippingOption'
import { log } from '@/services/Log'
import type { ApplePayHandlerBuilderInput } from '../types'
import { withSessionCancelationHandling } from './withSessionCancelationHandling'

const rawHandleShippingMethodSelected = ({
  session,
  onAbort,
  orderParser,
}: ApplePayHandlerBuilderInput) => async (
  event: ApplePayJS.ApplePayShippingMethodSelectedEvent,
) => {
  log('Apple Pay onshippingmethodselected: ', event)
  if (event.shippingMethod.identifier) {
    const cart = await getCart()
    if (!cart) {
      await onAbort()
      throw new Error('No cart found')
    }
    const order = await getOrder({ cart })
    const result = await updateShippingOption({
      order,
      shippingOptionId: event.shippingMethod.identifier,
      shipmentId: order.shipments[0].id,
    })

    const newOrder = (
      result.success && result.newOrder
        ? result.newOrder
        : await getOrder({ cart })
    )

    const newApplePayData = orderParser(newOrder)
    session.completeShippingMethodSelection({
      newTotal: newApplePayData.total,
      newLineItems: newApplePayData.lineItems,
    })
  }
}

export const handleShippingMethodSelected = (
  withSessionCancelationHandling(rawHandleShippingMethodSelected)
)
export default handleShippingMethodSelected
